var _metadata, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamgs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 10 10",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M4 1h2M3 2h1M6 2h1M2 3h2M6 3h2M1 4h1M8 4h1M1 5h1M8 5h1M2 6h2M6 6h2M3 7h1M6 7h1M4 8h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b2e285",
    d: "M4 2h2M4 3h1M2 4h2M2 5h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00e55b",
    d: "M5 3h1M4 4h3M3 5h3M4 6h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2aa374",
    d: "M7 4h1M6 5h2M5 6h1M4 7h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamgs);
export default __webpack_public_path__ + "static/media/teamgs.96c654eb144447023b97690948e33c69.svg";
export { ForwardRef as ReactComponent };